import { createAsyncThunk } from '@reduxjs/toolkit';

import loggerGenerator from '@travel/logger';

import { apiPath } from 'constants/api';

import type { ApiClient } from '@travel/api-client';
import type { ProviderSummary } from './types';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchProviderSummary = createAsyncThunk<
  ProviderSummary,
  number,
  { extra: { apiClient: ApiClient } }
>(
  'providerSummary/fetchCategoryScore',
  async (providerId, { extra: { apiClient }, rejectWithValue }) => {
    try {
      const data = await apiClient.get(apiPath.providerReviewSummary.pathname(providerId));

      return data;
    } catch (error) {
      logger.error('Fetch Category Score Error', error);
      noticeError('Fetch Category Score Error', error);

      return rejectWithValue(error);
    }
  },
);
